<template>
    <div class="m-auto" v-if="isLoaded && mission" data-cy="container_history_getfriend_list">
        <div class="flex items-center font-bold">
            <div class="text-18 text-a-black-3b3b3b" data-cy="text_history_getfriend_invite_count">
                {{ `${lbl.history.mission.fgf_invite} ${mission.Current}/${allStamp} ${lbl.history.mission.fgf_invite_unit}`}}
            </div>
            <div class="text-14 text-a-blue-0064ff ml-auto">
            <router-link to="/getfriend/history" class="text-a-blue-0064ff" data-cy="link_history_getfriend_view_history">
                {{ lbl.history.mission.fgf_view_history }}
            </router-link>  
            </div>
        </div>
        <div class="pt-3 pb-5" data-cy="container_history_getfriend_progress">
            <img :src="getFgfImage(mission.Current)" alt="invite-friend" data-cy="img_history_getfriend_progress">
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
import ModalMixin from '@/mixin/ModalMixin';
//component
import ConfigManager from '@/config/ConfigManager.js';
//service
import MissionService from '@/module/Mission/service/MissionService.js';

export default {
    name: 'GetFriendList',
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            isLoaded: false,
            mission: null,
            allStamp: 0,
            //unitCount: '',
            
            // FGF Background Images
            fgfImages: {},
        };
    },
    created: function() {
        this.initFgfImages();
        this.initialMission();
    },
    methods: {
        initialMission: async function() {
            this.modal.loadingModal.show();
            let badge = await this.getBadge();
            this.modal.loadingModal.hide();

            if (badge) {
                badge.filter((item) => {
                    
                    if(item.PartitionKey.indexOf('BBL_FriendGetFriends') >= 0) {
                        console.log('item.PartitionKey', item)
                        this.allStamp = item.MaxLevels;
                    }

                    this.mission = item.Missions.filter((res) => {
                        return (res.TracePlanId.indexOf('BBL_FriendGetFriends') >= 0);
                    })[0];
                });
                this.isLoaded = true;
            }
            
            //this.unitCount = this.getUnitTxt();
            console.log('mission', this.mission);
            console.log('allStamp', this.allStamp)
        },
        getBadge: function() {
            return new Promise((resolve) => { 
                MissionService.getBadge('bbl_referral_user').subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        this.errorApi(err);
                        resolve(null);

                    }
                });
            });
        },
        initFgfImages: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // Initialize all FGF background images
            for (let i = 0; i <= 10; i++) {
                this.fgfImages[i] = baseUrl + `fgf/bg-fgf-${i}.png`;
            }
        },
        getFgfImage: function(index) {
            return this.fgfImages[index];
        },
        // getUnitTxt: function () { 
        //     var unitText = this.localeCode === 1033 && this.mission.Current > 1
        //                 ? this.lbl.history.mission.fgf_invite_unit + 's'
        //                 : this.lbl.history.mission.fgf_invite_unit;

        //     return unitText;
        // },
    },
}
</script>
<style lang="scss" scoped>
</style>
